import React, { useState } from 'react';
import { Platform, Pressable, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { isDarkTheme } from '@/constants/Colors';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import DropdownMenuItem from '@/components/DropdownMenu/DropdownMenuItem';

const light = { solid_color_primary: '#FFFFFF', solid_color_secondary: '#F5F5F5', solid_color_block: '#FFFFFF', border_color_secondary: '#E5E5E5', text_color_primary: '#040404', text_color_secondary: '#616161', text_color_tertiary: '#757575', color_destructive: '#C93434' };
const dark = { solid_color_primary: '#040404', solid_color_secondary: '#1C1C1C', solid_color_block: '#111111', border_color_secondary: '#383838', text_color_primary: '#FFFFFF', text_color_secondary: '#B3B3B3', text_color_tertiary: '#A3A3A3', color_destructive: '#FF7979' };
export function useHistoryColors() {
  const { theme } = useTheme();
  return isDarkTheme(theme) ? dark : light;
}
export function HistoryText({ color = 'primary', style, ...props }) {
  const colors = useHistoryColors();
  return <Text {...props} style={[{ color: colors[`text_color_${color}`] }, style]} />;
}

export function HistoryMenu({ label, accessibilityLabel, icon, options, value, onChange }) {
  const colors = useHistoryColors();
  const [hovered, setHovered] = useState(false);
  return <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild={Platform.OS === 'web' || Platform.OS === 'macos'}>
      <Pressable accessibilityRole="button" accessibilityLabel={accessibilityLabel || label}
        onHoverIn={() => setHovered(true)} onHoverOut={() => setHovered(false)} style={{ maxWidth: 260 }}>
        <View pointerEvents="none" style={{ flexDirection: 'row', alignItems: 'center', gap: 8,
          minHeight: 44, minWidth: 44, maxWidth: 260, paddingHorizontal: 12, borderRadius: 10,
          backgroundColor: hovered ? colors.solid_color_secondary : 'transparent' }}>
        {icon && <Icon name={icon} size={14} color={colors.text_color_secondary} />}
        {!!label && <HistoryText size="s" numberOfLines={1} style={{ flexShrink: 1 }}>{label}</HistoryText>}
        {!!label && <Icon name="chevron-down" size={9} color={colors.text_color_secondary} />}
        </View>
      </Pressable>
    </DropdownMenu.Trigger>
    <DropdownMenu.Content align="end" sideOffset={6} style={{ minWidth: 200 }}
      className={Platform.OS === 'web' ? 'DropdownMenuContent' : undefined}>
      {options.map(option => Platform.OS === 'web'
        ? <DropdownMenuItem key={option.id} title={option.label} icon={option.icon}
            isDanger={option.id === 'delete'} isActive={value === option.id} onSelect={() => onChange(option.id)} />
        : <DropdownMenu.Item key={option.id} destructive={option.id === 'delete'} onSelect={() => onChange(option.id)}>
            {value === option.id && <DropdownMenu.ItemIcon ios={{ name: 'checkmark' }} />}
            <DropdownMenu.ItemTitle>{option.label}</DropdownMenu.ItemTitle>
          </DropdownMenu.Item>)}
    </DropdownMenu.Content>
  </DropdownMenu.Root>;
}

export function HistoryViewToggle({ value, onChange, listLabel, gridLabel }) {
  const colors = useHistoryColors();
  return <View style={{ flexDirection: 'row', padding: 3, borderRadius: 10, backgroundColor: colors.solid_color_secondary }}>
    {[['grid', 'grid-2', gridLabel], ['list', 'bars', listLabel]].map(([id, icon, label]) => <Pressable key={id}
      accessibilityRole="button" accessibilityLabel={label} accessibilityState={{ selected: value === id }} onPress={() => onChange(id)}
      style={{ width: 40, height: 38, borderRadius: 7, alignItems: 'center', justifyContent: 'center',
        backgroundColor: value === id ? colors.solid_color_block : 'transparent' }}>
      <Icon name={icon} size={14} color={value === id ? colors.text_color_primary : colors.text_color_secondary} />
    </Pressable>)}
  </View>;
}
